import { Component } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { AlertController } from '../../services/alert-controller.service';

@Component({
  selector: 'app-loader-dialog',
  imports: [DialogModule],
  templateUrl: './loader-dialog.component.html'
})
export class LoaderDialogComponent {
  constructor(public alertController: AlertController) { /**/ }
}
